export const activityBy = {
  unit: "unit",
  jobRole: "jobRole"
};
